<template lang="pug">
    div
        // Loader Component
        v-flex#loading-payments-spinner-flex.mt-5.px-3(v-if="loadingPayments")
            FanLoader
            div(slot="loadingMsg"
                class="full-width text-xs-center headline my-2"
            ) Loading screen...
        // No Payments Links Available
        v-flex(v-else-if="!loadingPayments && paymentLinks.length < 1")
            v-flex.mt-5
                v-img.wf-mx-auto(:src="paymentImg" max-width="500px")
                .subheading#no-payment-links-subheading.mt-5 There are currently no transactions. Send an EasyLink above to get started.

        v-flex(id="payment-links-list-flex" v-else)
            template(v-for="link in paymentLinks")
                PaymentLinksListTile(
                    :amount="link.amount"
                    :customerName="link.customerName"
                    :expiresAt="link.expiresAt"
                    :href="link.href"
                    :activity="link.activities"
                    :companyName="link.companyName"
                    :status="link.status"
                    :transactionId="link.lastSubmitted ? link.lastSubmitted.transactionId : null"
                )

            template(v-if="loadMore" )
                v-btn(id="load-more-button", @click="loadMorePayments()", class="primary") Load More
</template>

<script>
    import FanLoader from 'Components/FanLoader.vue'
    import PaymentLinksListTile from 'Components/PaymentLinksListTile.vue'
    import { getPaymentsList } from 'Helpers/c4cAPIClient'

    export default {
        name: "PaymentLinkList",
        components: {
            FanLoader,
            PaymentLinksListTile,
        },
        data: () => ({
            loadingPayments: true,
            paymentImg: require('../assets/money_ac.svg'),
            paymentLinks: [],
            nextSegmentForLoadMore: null,
        }),

        async mounted() {
            if (this.loadingPayments) {
                await this.loadMorePayments()
                this.loadingPayments = false
            }
        },
        computed: {
            loadMore() {
                return !!(this.nextSegmentForLoadMore)
            }
        },
        methods: {
            loadMorePayments: function() {
                return getPaymentsList(this.$store.state.user.dealerId, 6, this.nextSegmentForLoadMore)
                .then(res => {
                    this.paymentLinks = this.paymentLinks.concat(res.data.links)
                    this.nextSegmentForLoadMore = res.data.nextSegment ? res.data.nextSegment : null
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .v-btn {
        margin-top: 5%;
    }
</style>